class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`.js-product-form, #product-form-installment`);
    for(const productForm of productForms) {
      const variantIdInputs = productForm.querySelectorAll('input[name="id"]')
      for(const input of variantIdInputs) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };


  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinations = document.querySelectorAll(`#${id}`)
        const source = html.querySelectorAll(`#${id}`)[0];
        const priceForms = document.querySelectorAll(`#price-${this.dataset.section}`)
        for (const dest of destinations) {
          if (source && dest) dest.innerHTML = source.innerHTML;
        }

        this.renderOutOfStock(html, this.dataset.section)

        for (const priceForm of priceForms) {
          priceForm?.classList.remove('visibility-hidden');
        }
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }).finally(() => {
        window.WhatSub.dispatch('PRODUCT_FORM_RENDERED')
      });
  }

  renderOutOfStock(html, section) {
    const destinations = document.querySelectorAll(`#out-of-stock-${section}`)
    const source = html.getElementById(`out-of-stock-${section}`)

    if(destinations && source) {
      for (const dest of destinations) {
        dest.innerHTML = source.innerHTML
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const forms = document.querySelectorAll(`#product-form-${this.dataset.section}`)

    for (const form of forms) {
      const addButton = form?.querySelector('[name="add"]');
      const addButtonSticky = form?.querySelector('.product-form__submit-sticky');

      if (!addButton && !addButtonSticky) continue;

      if (disable) {
        addButton.setAttribute('disabled', true);
        addButtonSticky.setAttribute('disabled', true);
        if (text) addButton.querySelector('.a-btn-text').textContent = text;
        if (text) addButtonSticky.querySelector('.a-btn-text').textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonSticky.removeAttribute('disabled');
        if(addButton.classList.contains('is-preorder')) {
          addButton.querySelector('.a-btn-text').innerHTML = '<svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart" fill="currentColor" fill-rule="nonzero"><path d="M10.8841765,16.5282353 C11.9076176,16.5282353 12.7402059,17.3682353 12.7402059,18.3997058 C12.7402059,19.425 11.9076176,20.265 10.8841765,20.265 C9.8607353,20.265 9.02814706,19.425 9.02814706,18.3997058 C9.02814706,17.3682353 9.8607353,16.5282353 10.8841765,16.5282353 Z M22.0777941,16.5282353 C23.1012353,16.5282353 23.9338235,17.3682353 23.9338235,18.3997058 C23.9338235,19.425 23.1012353,20.265 22.0777941,20.265 C21.0543529,20.265 20.2217647,19.425 20.2217647,18.3997058 C20.2217647,17.3682353 21.0543529,16.5282353 22.0777941,16.5282353 Z M23.2964118,12.6741176 L9.32708824,12.6741176 L7.27155883,4.81764706 L25.1017941,4.83617647 L23.2964118,12.6741176 Z M26.9905588,3.33529412 C26.8151471,3.11294118 26.5489412,2.98941176 26.2666765,2.98323529 L6.78608824,2.96470588 L6.19252942,0.691764706 C6.08567647,0.284117647 5.71755883,-3.55271368e-15 5.29632353,-3.55271368e-15 L0.926470588,-3.55271368e-15 C0.414441177,-3.55271368e-15 0,0.413823529 0,0.926470591 C0,1.43911765 0.414441177,1.85294118 0.926470588,1.85294118 L4.58108824,1.85294118 L5.16970589,4.10117647 C5.17279412,4.11970588 5.1765,4.13205882 5.18020589,4.14441176 L7.71502942,13.8352941 C7.82188236,14.2429411 8.19,14.5270588 8.61185295,14.5270588 L24.0332647,14.5270588 C24.465,14.5270588 24.8392941,14.2305882 24.9362647,13.8105882 L27.1684412,4.11970588 C27.2320588,3.84794118 27.1665882,3.55764706 26.9905588,3.33529412 L26.9905588,3.33529412 Z" id="6G"></path></g></g></svg>' + ' ' + window.variantStrings.presale;
          addButtonSticky.querySelector('.a-btn-text').innerHTML = '<svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart" fill="currentColor" fill-rule="nonzero"><path d="M10.8841765,16.5282353 C11.9076176,16.5282353 12.7402059,17.3682353 12.7402059,18.3997058 C12.7402059,19.425 11.9076176,20.265 10.8841765,20.265 C9.8607353,20.265 9.02814706,19.425 9.02814706,18.3997058 C9.02814706,17.3682353 9.8607353,16.5282353 10.8841765,16.5282353 Z M22.0777941,16.5282353 C23.1012353,16.5282353 23.9338235,17.3682353 23.9338235,18.3997058 C23.9338235,19.425 23.1012353,20.265 22.0777941,20.265 C21.0543529,20.265 20.2217647,19.425 20.2217647,18.3997058 C20.2217647,17.3682353 21.0543529,16.5282353 22.0777941,16.5282353 Z M23.2964118,12.6741176 L9.32708824,12.6741176 L7.27155883,4.81764706 L25.1017941,4.83617647 L23.2964118,12.6741176 Z M26.9905588,3.33529412 C26.8151471,3.11294118 26.5489412,2.98941176 26.2666765,2.98323529 L6.78608824,2.96470588 L6.19252942,0.691764706 C6.08567647,0.284117647 5.71755883,-3.55271368e-15 5.29632353,-3.55271368e-15 L0.926470588,-3.55271368e-15 C0.414441177,-3.55271368e-15 0,0.413823529 0,0.926470591 C0,1.43911765 0.414441177,1.85294118 0.926470588,1.85294118 L4.58108824,1.85294118 L5.16970589,4.10117647 C5.17279412,4.11970588 5.1765,4.13205882 5.18020589,4.14441176 L7.71502942,13.8352941 C7.82188236,14.2429411 8.19,14.5270588 8.61185295,14.5270588 L24.0332647,14.5270588 C24.465,14.5270588 24.8392941,14.2305882 24.9362647,13.8105882 L27.1684412,4.11970588 C27.2320588,3.84794118 27.1665882,3.55764706 26.9905588,3.33529412 L26.9905588,3.33529412 Z" id="6G"></path></g></g></svg>' + ' ' + window.variantStrings.presale;
        } else {
          addButton.querySelector('.a-btn-text').innerHTML = '<svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart" fill="currentColor" fill-rule="nonzero"><path d="M10.8841765,16.5282353 C11.9076176,16.5282353 12.7402059,17.3682353 12.7402059,18.3997058 C12.7402059,19.425 11.9076176,20.265 10.8841765,20.265 C9.8607353,20.265 9.02814706,19.425 9.02814706,18.3997058 C9.02814706,17.3682353 9.8607353,16.5282353 10.8841765,16.5282353 Z M22.0777941,16.5282353 C23.1012353,16.5282353 23.9338235,17.3682353 23.9338235,18.3997058 C23.9338235,19.425 23.1012353,20.265 22.0777941,20.265 C21.0543529,20.265 20.2217647,19.425 20.2217647,18.3997058 C20.2217647,17.3682353 21.0543529,16.5282353 22.0777941,16.5282353 Z M23.2964118,12.6741176 L9.32708824,12.6741176 L7.27155883,4.81764706 L25.1017941,4.83617647 L23.2964118,12.6741176 Z M26.9905588,3.33529412 C26.8151471,3.11294118 26.5489412,2.98941176 26.2666765,2.98323529 L6.78608824,2.96470588 L6.19252942,0.691764706 C6.08567647,0.284117647 5.71755883,-3.55271368e-15 5.29632353,-3.55271368e-15 L0.926470588,-3.55271368e-15 C0.414441177,-3.55271368e-15 0,0.413823529 0,0.926470591 C0,1.43911765 0.414441177,1.85294118 0.926470588,1.85294118 L4.58108824,1.85294118 L5.16970589,4.10117647 C5.17279412,4.11970588 5.1765,4.13205882 5.18020589,4.14441176 L7.71502942,13.8352941 C7.82188236,14.2429411 8.19,14.5270588 8.61185295,14.5270588 L24.0332647,14.5270588 C24.465,14.5270588 24.8392941,14.2305882 24.9362647,13.8105882 L27.1684412,4.11970588 C27.2320588,3.84794118 27.1665882,3.55764706 26.9905588,3.33529412 L26.9905588,3.33529412 Z" id="6G"></path></g></g></svg>' + ' ' + window.variantStrings.addToCart;
          addButtonSticky.querySelector('.a-btn-text').innerHTML = '<svg width="28px" height="21px" viewBox="0 0 28 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Cart" fill="currentColor" fill-rule="nonzero"><path d="M10.8841765,16.5282353 C11.9076176,16.5282353 12.7402059,17.3682353 12.7402059,18.3997058 C12.7402059,19.425 11.9076176,20.265 10.8841765,20.265 C9.8607353,20.265 9.02814706,19.425 9.02814706,18.3997058 C9.02814706,17.3682353 9.8607353,16.5282353 10.8841765,16.5282353 Z M22.0777941,16.5282353 C23.1012353,16.5282353 23.9338235,17.3682353 23.9338235,18.3997058 C23.9338235,19.425 23.1012353,20.265 22.0777941,20.265 C21.0543529,20.265 20.2217647,19.425 20.2217647,18.3997058 C20.2217647,17.3682353 21.0543529,16.5282353 22.0777941,16.5282353 Z M23.2964118,12.6741176 L9.32708824,12.6741176 L7.27155883,4.81764706 L25.1017941,4.83617647 L23.2964118,12.6741176 Z M26.9905588,3.33529412 C26.8151471,3.11294118 26.5489412,2.98941176 26.2666765,2.98323529 L6.78608824,2.96470588 L6.19252942,0.691764706 C6.08567647,0.284117647 5.71755883,-3.55271368e-15 5.29632353,-3.55271368e-15 L0.926470588,-3.55271368e-15 C0.414441177,-3.55271368e-15 0,0.413823529 0,0.926470591 C0,1.43911765 0.414441177,1.85294118 0.926470588,1.85294118 L4.58108824,1.85294118 L5.16970589,4.10117647 C5.17279412,4.11970588 5.1765,4.13205882 5.18020589,4.14441176 L7.71502942,13.8352941 C7.82188236,14.2429411 8.19,14.5270588 8.61185295,14.5270588 L24.0332647,14.5270588 C24.465,14.5270588 24.8392941,14.2305882 24.9362647,13.8105882 L27.1684412,4.11970588 C27.2320588,3.84794118 27.1665882,3.55764706 26.9905588,3.33529412 L26.9905588,3.33529412 Z" id="6G"></path></g></g></svg>' + ' ' + window.variantStrings.addToCart;
        }
      }

      if (!modifyClass) continue;
    }
  }

  setUnavailable() {
    const forms = document.querySelectorAll(`#product-form-${this.dataset.section}`)
    const priceForms = document.querySelectorAll(`#price-${this.dataset.section}`)
    for (const form of forms) {
      const addButton = form?.querySelector('[name="add"]');
      const addButtonSticky = form?.querySelector('.product-form__submit-sticky');

      if (!addButton && !addButtonSticky) continue;

      addButton.textContent = window.variantStrings.unavailable;
      addButtonSticky.textContent = window.variantStrings.unavailable;
    }

    for(const priceForm of priceForms) {
      priceForm?.classList.add('visibility-hidden');
    }

  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
